import { useState } from "react";
import { useRouter } from "next/router";
import Icon, { SearchOutlined } from "@ant-design/icons";
import { Button, Popover, Space } from "antd";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import EditIcon from "~/components/app/EditIcon";
import AppSearch from "~/components/app/AppSearch";
import usePrefs from "~/hooks/usePrefs";
import { showAppModal } from "~/redux/actions/app";

const MobileFloatingActions = (props) => {
  const router = useRouter();
  const { prefs } = usePrefs();
  const [postOpen, setPostOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const pathname = router.pathname || "";
  const hideSearchAction = pathname === "/search";
  const hidePostAction = pathname === "/posts/new" || pathname === "/jobs/new";

  if (hideSearchAction && hidePostAction) {
    return null;
  }

  const handleLinkToNewPost = () => {
    if (props.token) {
      router.push("/posts/new");
      setPostOpen(false);
    } else {
      props.showAppModal("PhoneSigninModal");
      setPostOpen(false);
    }
  };

  const handleLinkToNewJob = () => {
    if (!props.token) {
      props.showAppModal("PhoneSigninModal");
      setPostOpen(false);
      return;
    }

    if (prefs.job_post_ui_version === "v2") {
      props.showAppModal("NewJobModalV2");
    } else {
      props.showAppModal("NewJobModal");
    }
    setPostOpen(false);
  };

  const postPopoverContent = (
    <Space
      direction="vertical"
      style={{ width: 120 }}
    >
      <Button
        type="primary"
        onClick={handleLinkToNewPost}
        block
      >
        发布话题
      </Button>
      <Button
        type="primary"
        onClick={handleLinkToNewJob}
        block
      >
        发布招聘
      </Button>
    </Space>
  );

  return (
    <>
      <div className="mobile-floating-actions">
        {!hidePostAction && (
          <Popover
            placement="topRight"
            trigger="click"
            open={postOpen}
            onOpenChange={(open) => {
              setPostOpen(open);
              if (open) {
                setSearchOpen(false);
              }
            }}
            content={postPopoverContent}
            overlayClassName="mobile-floating-post-popover"
          >
            <button
              type="button"
              className="floating-action-btn"
              aria-label="发布"
            >
              <Icon
                component={EditIcon}
                style={{ fontSize: 20 }}
              />
            </button>
          </Popover>
        )}
        {!hideSearchAction && (
          <Popover
            placement="topRight"
            trigger="click"
            open={searchOpen}
            onOpenChange={(open) => {
              setSearchOpen(open);
              if (open) {
                setPostOpen(false);
              }
            }}
            content={
              <div className="mobile-search-popover">
                <AppSearch />
              </div>
            }
            overlayClassName="mobile-floating-search-popover"
          >
            <button
              type="button"
              className="floating-action-btn"
              aria-label="搜索"
            >
              <SearchOutlined style={{ fontSize: 20 }} />
            </button>
          </Popover>
        )}
      </div>
      <style jsx>{`
        .mobile-floating-actions {
          display: none;
        }

        @media screen and (max-width: 767px) {
          .mobile-floating-actions {
            position: fixed;
            right: 60px;
            bottom: 100px;
            z-index: 1000;
            display: flex;
            flex-direction: column;
            gap: 10px;
          }

          .floating-action-btn {
            width: 40px;
            height: 40px;
            border: none;
            border-radius: 20px;
            background: #f9ba48;
            color: #fff;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
            cursor: pointer;
            padding: 0;
          }
        }

        @media screen and (max-width: 480px) {
          .mobile-floating-actions {
            right: 20px;
          }
        }
      `}</style>
      <style
        jsx
        global
      >{`
        .mobile-floating-search-popover .ant-popover-inner-content {
          width: min(78vw, 320px);
          padding: 10px;
        }

        .mobile-floating-search-popover .app-search {
          width: 100% !important;
          margin-bottom: 0 !important;
        }
      `}</style>
    </>
  );
};

const mapStateToProps = (state) => ({
  token: state.user?.token,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showAppModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileFloatingActions);
